export const typeOptions = [
  { id: 'Dealer', label: 'Dealer' },
  { id: 'UserDealer', label: 'User' },
  { id: 'Login', label: 'Login' },
  { id: 'FormPack', label: 'Form Pack' },
  { id: 'FormTemplate', label: 'Form' },
  { id: 'WidgetConfig', label: 'Buttons' },
  { id: 'DealerPriceRules', label: 'Pricing Matrix' },
  { id: 'Configuration', label: 'Pricing Configuration' },
];

export const fieldOptions = {
  Dealer: [
    {
      id: 'aprConfig',
      label: 'APR Config',
    },
    {
      id: 'addOns',
      label: 'Add Ons',
    },
    {
      id: 'address',
      label: 'Address',
    },
    {
      id: 'brand',
      label: 'Brand',
    },
    {
      id: 'signedOn',
      label: 'Signed On',
    },
    {
      id: 'liveAt',
      label: 'Live At',
    },
    {
      id: 'cancelledAt',
      label: 'Cancelled At',
    },
    {
      id: 'contactEmail',
      label: 'Main Point of Contact',
    },
    {
      id: 'crmConfig',
      label: 'CRM Config',
    },
    {
      id: 'crmType',
      label: 'CRM Type',
    },
    {
      id: 'city',
      label: 'City',
    },
    {
      id: 'controlPanelFlow',
      label: 'Control Panel Flow',
    },
    {
      id: 'country',
      label: 'Country',
    },
    {
      id: 'county',
      label: 'County',
    },
    {
      id: 'dealPrice',
      label: 'Deal Price',
    },
    {
      id: 'deliveryRadius',
      label: 'Deliver Radius',
    },
    {
      id: 'deliveryEnd',
      label: 'Delivery End',
    },
    {
      id: 'deliveryHours',
      label: 'Delivery Hours',
    },
    {
      id: 'deliveryStart',
      label: 'Delivery Start',
    },
    {
      id: 'desking',
      label: 'Desking',
    },
    {
      id: 'dsm',
      label: 'DSM',
    },
    {
      id: 'fniType',
      label: 'FNI Type',
    },
    {
      id: 'featureConfig',
      label: 'Feature Config',
    },
    {
      id: 'fees',
      label: 'Fees',
    },
    {
      id: 'financeEmail',
      label: 'Finance Email',
    },
    {
      id: 'inStoreAprConfig',
      label: 'In Store APR Config',
    },
    {
      id: 'localizationConfig',
      label: 'Localization Config',
    },
    {
      id: 'logo',
      label: 'Logo',
    },
    {
      id: 'managers',
      label: 'Managers',
    },
    {
      id: 'name',
      label: 'Name',
    },
    {
      id: 'pickupEnd',
      label: 'Pickup End',
    },
    {
      id: 'pickupHours',
      label: 'Pickup Hours',
    },
    {
      id: 'pickupStart',
      label: 'Pickup Start',
    },
    {
      id: 'printingType',
      label: 'Printing Type',
    },
    {
      id: 'protectionPlans',
      label: 'Protection Plans',
    },
    {
      id: 'state',
      label: 'State',
    },
    {
      id: 'stickerPrice',
      label: 'Sticker Price',
    },
    {
      id: 'supportEmail',
      label: 'Support Email',
    },
    {
      id: 'tabletFormsConfig',
      label: 'Tablet Forms Config',
    },
    {
      id: 'taxes',
      label: 'Taxes',
    },
    {
      id: 'testDriveDuration',
      label: 'Test Drive Duration',
    },
    {
      id: 'testDriveSpeed',
      label: 'Test Drive Speed',
    },
    {
      id: 'timezone',
      label: 'Timezone',
    },
    {
      id: 'tradeInManagerType',
      label: 'Trade-in Manager Type',
    },
    {
      id: 'valueGuarantee',
      label: 'Value Guarantee',
    },
    {
      id: 'wizard',
      label: 'Wizard',
    },
    {
      id: 'zip',
      label: 'ZIP',
    },
  ],
  UserDealer: [
    {
      id: 'crmLogin',
      label: 'CRM Login',
    },
    {
      id: 'crmUserId',
      label: 'CRM User ID',
    },
    {
      id: 'email',
      label: 'Email',
    },
    {
      id: 'firstName',
      label: 'First Name',
    },
    {
      id: 'lastName',
      label: 'Last Name',
    },
    {
      id: 'phone',
      label: 'Phone',
    },
    {
      id: 'roles',
      label: 'Roles',
    },
  ],
  Login: [
    { id: 'type', label: 'Type' },
    { id: 'login', label: 'Login' },
  ],
  FormPack: [
    { id: 'name', label: 'Name' },
    { id: 'FormTemplates', label: 'Form Templates' },
  ],
  FormTemplate: [
    { id: 'name', label: 'Name' },
    { id: 'url', label: 'URL' },
  ],
  WidgetConfig: [
    { id: 'VDP', label: 'Vehicle Details' },
    { id: 'SRP', label: 'Search Results' },
    { id: 'STANDALONE', label: 'Standalone Buttons' },
  ],
};
